module.exports = __webpack_public_path__ + "img/elite_logo_transparent.70864a3e.png";